/**
 * Configuration for redirect handlers and their required parameters
 */

export type RedirectModule = "project";

export interface RedirectModuleConfig {
  /** Human-readable name for the module */
  displayName: string;
  /** Required URL parameters for this module */
  requiredParams: string[];
  /** Optional URL parameters for this module */
  optionalParams?: string[];
}

/**
 * Defines supported modules and their parameter requirements
 * Add new modules here as needed (e.g., 'site', 'document', etc.)
 */
export const REDIRECT_MODULE_CONFIG: Record<
  RedirectModule,
  RedirectModuleConfig
> = {
  project: {
    displayName: "Project",
    requiredParams: ["ProjectId", "ProgrammeId"],
    optionalParams: [],
  },
  // Future modules can be added here:
  // site: {
  //   displayName: "Site",
  //   requiredParams: ["SiteId"],
  //   optionalParams: ["ProgrammeId"],
  // },
};

/**
 * Valid module names for type checking
 */
export const VALID_MODULES = Object.keys(
  REDIRECT_MODULE_CONFIG
) as RedirectModule[];

/**
 * localStorage key for storing pending redirect information
 */
export const REDIRECT_LOCATION_KEY = "RedirectLocation";

/**
 * Duration before a stored redirect expires (in milliseconds)
 * Default: 5 minutes
 */
export const REDIRECT_EXPIRATION_MS = 5 * 60 * 1000; // 5 minutes
